export enum OrderDirection {
    asc = 'asc',
    desc = 'desc',
}

export type OrderBy = {
    orderBy: string;
    orderDirection: OrderDirection;
};
